import { RootState } from "../reducers";

export const selectOffices = (state: RootState) => state.offices.offices.data;
